/**
 * Login redirect target. Full URL or path on the same origin.
 * Set to empty string to keep the default Flarum login modal.
 */
export const OIDC_LOGIN_URL = '/auth/oidc?provider=keycloak_main';
flarum.reg.add('dia-theme', 'forum/features/oidc-login/config', { OIDC_LOGIN_URL: OIDC_LOGIN_URL, });